import { AudioConversationDetail } from '../../services/types/audio-conversation-types';

/**
 * Formats the duration into a MM:SS format
 */
export const formatCallDuration = (
  currentTime: number,
  totalDuration: number,
): string => {
  const formatTime = (time: number): string => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return `${formatTime(currentTime)}/${formatTime(totalDuration)}`;
};

/**
 * Formats the call metadata into a readable string
 */
export const formatAudioCall = (
  conversation: AudioConversationDetail,
): string => {
  const startDate = new Date(conversation.start_timestamp);

  const formattedDate = startDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });

  const formattedTime = startDate.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });

  return `${formattedDate} at ${formattedTime}`;
};

/**
 * Format phone number in a readable format: (XXX) XXX-XXXX
 */
export const formatPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return '';

  // Strip any non-numeric characters
  const cleaned = phoneNumber.replace(/\D/g, '');

  // Format the number as (XXX) XXX-XXXX
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  return phoneNumber;
};

/**
 * Calculates the duration in minutes:seconds format from a duration string
 */
export const formatDuration = (duration: string): string => {
  // Duration is in format "00:05:23"
  const parts = duration.split(':');

  if (parts.length === 3) {
    const hours = parseInt(parts[0], 10);
    const minutes = parseInt(parts[1], 10);
    const seconds = parseInt(parts[2], 10);

    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s`;
    }
    return `${minutes}m ${seconds}s`;
  }

  return duration;
};
